module.exports = __webpack_public_path__ + "static/img/level-card-banner2.c13bac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/2/level-card-banner2.png
// module id = qlQk
// module chunks = 1